import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { IAdaptiveSingleLineTextProps } from './AdaptiveSingleLineText.types';

import Tooltip from '../Tooltip';

import './AdaptiveSingleLineText.scss';

const AdaptiveSingleLineText: React.FC<IAdaptiveSingleLineTextProps> = ({
	text,
	maxWidth,
	styleInline,
	className,
	onClick,
	paddingsSize = 30,
}) => {
	const textRef = useRef<HTMLInputElement | null>(null);
	const widthWithoutPaddings = maxWidth - paddingsSize;

	const [isFullSize, setIsFullSize] = useState(false);

	const calculateFullSize = useCallback(() => {
		if (!text?.length) return;

		if (textRef?.current?.offsetWidth) {
			const fullSizeCol = textRef.current.offsetWidth + paddingsSize;

			setIsFullSize(fullSizeCol <= maxWidth);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text?.length]);

	useLayoutEffect(() => {
		calculateFullSize();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text, textRef.current]);

	return (
		<div
			className={cn('f5gAdaptiveSingleLineTextContainer', className)}
			onClick={onClick}
			style={styleInline}
		>
			<Tooltip
				content={text}
				isDisabled={isFullSize}
				placement='top'
			>
				<span
					ref={textRef}
					className='f5gAdaptiveSingleLineTextEllipsis'
					style={{
						display: !isFullSize ? 'block' : 'inline',
						maxWidth: `${widthWithoutPaddings}px`,
					}}
				>
					{text}
				</span>
			</Tooltip>
		</div>
	);
};

export default AdaptiveSingleLineText;
